import PropTypes from 'prop-types'
import { Typography } from '../Typography'
import { LinkButton } from '../Contentful'

const ButtonCTAv2 = (props) => {
  const { title = '', items = [], url = '#', buttonText = '', underButtonText = '' } = props

  return (
    <div className="bg-[#F8F8F8] flex items-center justify-center py-7 px-4 lg:py-8 lg:px-2 w-full">
      <div className="flex flex-col gap-y-6 items-center w-full">
        {title && <Typography content={title} className="headingMd text-center" />}
        {items.length > 0 && (
          <ul className="flex flex-col gap-y-4 items-start md:items-center text-[#262930] p-0! m-0!">
            {items.map((item) => (
              <li key={item} className="flex gap-x-2">
                <div className="mt-1">
                  <svg
                    width="21"
                    height="17"
                    viewBox="0 0 22 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-4 sm:w-6"
                  >
                    <path
                      d="M21.5451 2.48158L19.8256 0.76204C19.5081 0.445368 18.9956 0.445368 18.6789 0.76204L8.36897 11.072L3.46499 6.13257C3.14832 5.8159 2.63584 5.8159 2.31837 6.13257L0.598832 7.8521C0.28216 8.16958 0.28216 8.68206 0.598832 8.99873L7.78962 16.2379C8.10629 16.5545 8.61957 16.5545 8.93624 16.2379L21.5451 3.6282C21.8618 3.31234 21.8618 2.79825 21.5451 2.48158Z"
                      fill="#048155"
                    />
                  </svg>
                </div>
                <Typography content={item} className="bodyMd text-left  lg:text-center" />
              </li>
            ))}
          </ul>
        )}
        {(buttonText || underButtonText) && (
          <div className="flex flex-col gap-y-3 w-full mx-auto items-center">
            <LinkButton
              track={{
                list_name: 'CTA CARD',
                click_position: '0',
                track_event: 'page_nav_click',
                event_action: 'button_click',
                event_type: 'button_click',
                click_id: buttonText,
                click_text: buttonText,
                nav_link_section: `CTA Card - In-Content`,
                click_type: 'page_nav_click',
              }}
              className="min-w-[347px]"
              content={{
                linkHref: url,
                // linkText: buttonText,
                linkText: buttonText,
                uiComponent: 'LinkButton',
              }}
              data-testid="cta-button"
              color="primary"
              variant="contained"
            />
            {underButtonText && (
              <Typography content={underButtonText} className="bodyXs text-gray-500 text-center" />
            )}
          </div>
        )}
      </div>
    </div>
  )
}

ButtonCTAv2.propTypes = {
  title: PropTypes.string,
  items: PropTypes.array,
  url: PropTypes.string,
  buttonText: PropTypes.string,
  underButtonText: PropTypes.string,
  position: PropTypes.number,
}

export default ButtonCTAv2
